import { render, staticRenderFns } from "./UserTicket.vue?vue&type=template&id=efce66e8&scoped=true&"
import script from "./UserTicket.vue?vue&type=script&lang=js&"
export * from "./UserTicket.vue?vue&type=script&lang=js&"
import style0 from "./UserTicket.vue?vue&type=style&index=0&id=efce66e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efce66e8",
  null
  
)

export default component.exports